import * as React from 'react';
import { observer } from 'mobx-react';
import { WorkflowTabs } from 'typings/enums';
import { WorkflowHrRoles } from 'nomst/Components/WorkflowSettings/workflowHrRoles';
import { WorkflowConfigurationView } from 'nomst/Components/WorkflowSettings/workflowConfigurationView';
import { WorkflowConfiguration } from 'nomst/Stores/Configuration/workflowConfiguration';
import { workflowSettingsViewStore } from 'utils/MobxDataManager/singletons';
import './workflowSettingsView.scss';

export interface IWorkflowSettingsViewProps {
    workflowConfiguration: WorkflowConfiguration;
    readonly?: boolean;
}

export class WorkflowSettingsView extends React.Component<IWorkflowSettingsViewProps> {
    constructor(props: IWorkflowSettingsViewProps) {
        super(props);

        this.handleSelectHrRolesTab = this.handleSelectHrRolesTab.bind(this);
        this.handleSelectWorkflowConfigTab = this.handleSelectWorkflowConfigTab.bind(this);
    }

    render(): React.ReactNode {
        return (
            <div className="nomst-workflow-settings">
                <h1 className="nomst-workflow-settings__title pxl-header-sm">
                    Workflow Settings
                </h1>
                <nav className="tabs tabs--condensed">
                    <button
                        className={this.getTabClasses(WorkflowTabs.HrRoles)}
                        onClick={this.handleSelectHrRolesTab}
                    >
                        HR Roles
                    </button>
                    <button
                        className={this.getTabClasses(WorkflowTabs.WorkflowConfiguration)}
                        onClick={this.handleSelectWorkflowConfigTab}
                    >
                        Workflow
                    </button>
                </nav>
                <section className="nomst-workflow-settings__tab-content">
                    {this.renderTabContent()}
                </section>
            </div>
        );
    }

    private renderTabContent(): React.ReactNode {
        const { workflowConfiguration, readonly } = this.props;
        switch (workflowSettingsViewStore.tab) {
            case WorkflowTabs.HrRoles:
                return (
                    <WorkflowHrRoles
                        readonly={readonly}
                    />
                );
            case WorkflowTabs.WorkflowConfiguration:
                return (
                    <WorkflowConfigurationView
                        workflowConfiguration={workflowConfiguration}
                        readonly={readonly}
                    />
                );
            default:
                return null;
        }
    }

    private getTabClasses(tab: WorkflowTabs): string {
        const activeClass = (workflowSettingsViewStore.tab === tab) ? 'active' : '';
        return `tab ${activeClass} nomst-workflow-settings__--${WorkflowTabs.HrRoles} pxl-link`;
    }

    private handleSelectHrRolesTab(): void {
        workflowSettingsViewStore.changeDetailTabGlobal(WorkflowTabs.HrRoles);
    }

    private handleSelectWorkflowConfigTab(): void {
        workflowSettingsViewStore.changeDetailTabGlobal(WorkflowTabs.WorkflowConfiguration);
    }
}

export default observer(WorkflowSettingsView);